import React from "react";
import MainRoutes from "./routes.tsx";
import { BrowserRouter as Router } from "react-router-dom";

const AppRoutes = () => {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  return mounted ? (
    <Router>
      <MainRoutes />
    </Router>
  ) : null;
};

export default AppRoutes;
